import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { ArrowRight } from "lucide-react";

const CATEGORIES = [
  { label: "Watches", cat: "fashion", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/629dda6f42cff7e122e557b7c7f9c3150a5bde8c1d8352496d999d85a21870a4.jpeg" },
  { label: "Designer bags", cat: "fashion", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/668b5fc7e1772e9be6475c08f602c41736124fa24e1f8805f832440680066daa.jpeg" },
  { label: "Footwear", cat: "fashion", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/f7e3c89d9eb496592118ea3e64919195a771b8f8dd9d0ec2d2613f91dd27bbac.jpeg" },
  { label: "Dresses", cat: "fashion", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/21a5cc5b31d93776a15ed10f78d0f6c8c1dbb7e6e51118409fe72c96a4ed047a.jpeg" },
  { label: "Food & groceries", cat: "grocery", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/ad2d0fa45b0ca6bccd9bc14ce7ec9b7cff5ff6d08f6aba886958cd975f63485c.jpeg" },
  { label: "Pet food", cat: "pets", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/e3b74dc171c802ea99ec8a9f40af0f80b3970c2854b4ae23979f54043d5dd7f5.jpeg" },
  { label: "Children's toys", cat: "toys", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/fce5f921b186cef3951637fb630e9b09623243421eae357c2b022b644cda1949.jpeg" },
  { label: "Electronics", cat: "electronics", img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/b7135250e6effba4ebd3d916983991e997ff1102328cb2e8473c82b53947c02c.jpeg" },
];

const TRADERS = [
  {
    img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/573e9397a794bccf1ae4ea3dbf0de8b08a764c6c63b49811c2cffcef42048655.jpeg",
    quote: "Publish in the morning, pack orders by evening. Fresh drops keep my whole catalog moving.",
    who: "High-volume seller",
  },
  {
    img: "https://static.prod-images.emergentagent.com/jobs/0ab4441c-cd50-42d2-a869-38101b76f29a/images/1d48b59a0eff671164af064ddefc867a8051213b130b058f2a1950c472bcbf35.jpeg",
    quote: "One photo, one listing, and my bags are in front of buyers who actually want them.",
    who: "Fashion trader",
  },
];

export function HeroMontage() {
  const [slides, setSlides] = useState(CATEGORIES.map((c) => c.img));

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/products/hero-showcase");
        if (data.count >= 3) {
          const origin = API_BASE.replace(/\/api$/, "");
          const real = data.products.map((p) => `${origin}${p.image_url}`);
          const padded = [];
          for (let i = 0; padded.length < 8 && real.length > 0; i++) padded.push(real[i % real.length]);
          setSlides(padded);
        }
      } catch { /* keep category fallback */ }
    })();
  }, []);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" data-testid="hero-montage" aria-hidden="true">
      {slides.map((src, i) => (
        <div key={`${src}-${i}`} className="vsk-montage-slide" style={{ animationDelay: `${i * 4}s`, animationDuration: `${slides.length * 4}s` }}>
          <img src={src} alt="" loading={i === 0 ? "eager" : "lazy"} className="w-full h-full object-cover" />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]/40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/60" />
    </div>
  );
}

export function CategoryMarquee() {
  const cards = [...CATEGORIES, ...CATEGORIES];
  return (
    <section className="border-t border-white/5 py-16 overflow-hidden" data-testid="category-marquee">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-widest text-[#FF3B30]">Everything sells here</div>
        <h2 className="mt-2 font-black tracking-tight text-lg md:text-lg">
          Bags, footwear, dresses, groceries, pet food, toys — every category stays live, always.
        </h2>
      </div>
      <div className="mt-8 vsk-showcase">
        <div className="vsk-showcase-track">
          {cards.map((c, i) => (
            <Link to={`/discover?category=${c.cat}`} key={i} className="vsk-card group" data-testid={i < CATEGORIES.length ? `category-card-${i}` : undefined}>
              <div className="h-56 w-56 md:h-64 md:w-64 rounded-xl overflow-hidden border border-white/10 group-hover:border-[#FF3B30]/60 transition-colors">
                <img src={c.img} alt={c.label} loading="lazy" className="vsk-kenburns h-full w-full object-cover" style={{ animationDelay: `${(i % 7) * -2.5}s` }} />
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-sm font-bold text-white">{c.label}</span>
                <ArrowRight className="h-3.5 w-3.5 text-[#FF3B30] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <span className="text-[10px] uppercase tracking-widest text-neutral-500">Always live</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TraderExperiences() {
  return (
    <section className="border-t border-white/5 py-20" data-testid="trader-experiences">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#FF3B30]">Built for traders</div>
            <h2 className="mt-2 font-black tracking-tight text-lg md:text-lg">The VISMARKS hustle, in motion.</h2>
          </div>
          <span className="text-[10px] uppercase tracking-widest text-neutral-500 border border-white/10 rounded-full px-3 py-1.5">
            Illustrative examples
          </span>
        </div>
        <div className="mt-8 grid md:grid-cols-2 gap-6">
          {TRADERS.map((t, i) => (
            <div key={i} className="group relative rounded-2xl overflow-hidden border border-white/10" data-testid={`trader-card-${i}`}>
              <img src={t.img} alt={t.who} loading="lazy" className="vsk-kenburns w-full h-72 md:h-80 object-cover" style={{ animationDelay: `${i * -6}s` }} />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-white font-bold text-base leading-snug">"{t.quote}"</p>
                <div className="mt-2 text-xs uppercase tracking-widest text-[#FF3B30]">{t.who}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
